<div class="navigation-bar">
  <ng-container *ngIf="currentTask">
    <span>Task # <strong>{{currentTask.id}}</strong></span>
    <app-status-indicator class="item" [date]="currentTask.dateReceived"
                          [statusText]="currentTask.status"></app-status-indicator>
    <app-request-type-indicator class="item" [taskType]="currentTask.type"></app-request-type-indicator>
    @if (currentTask.subType){
      <app-enrollment-type-indicator [enrollmentType]="EnrollmentTypeIntMap.get(currentTask.subType)"></app-enrollment-type-indicator>
    }
    @else {
      <span class="item centered description">{{currentTask.description}}</span>
    }
  </ng-container>
</div>
